<template>
  <div>
    <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense v-if="!dataReady">
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>

              <v-col cols="12">
                <v-sheet tile height="54" class="d-flex">
                  <v-select
                    v-model="month"
                    :items="monthNameTH"
                    dense
                    outlined
                    hide-details
                    label="เดือน"
                    class="ma-2"
                  ></v-select>
                  <v-select
                    v-model="year"
                    :items="yearsNumber"
                    dense
                    outlined
                    hide-details
                    label="ปี"
                    class="ma-2"
                  ></v-select>
                  <v-icon color="#871B12" size="30" @click="getData()"
                    >mdi-calendar-search</v-icon
                  >
                </v-sheet>
              </v-col>
            </v-card>

            <v-tabs-items v-model="tabs">
              <v-tab-item value="request">
                <v-card>
                  <v-tabs v-model="tabsHeaer" fixed-tabs>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      id="request_waiting"
                      href="#request_waiting"
                      class="primary--text"
                      @click="getDataRequest('verify')"
                    >
                      <v-icon>mdi-clock</v-icon>รออนุมัติ
                      <v-badge
                        v-if="dataCountItem > 0"
                        color="red"
                        :content="dataCountItem"
                      >
                      </v-badge>
                    </v-tab>
                    <v-tab
                      @click="getDataRequest('history')"
                      id="approve_history"
                      href="#approve_history"
                      class="primary--text"
                    >
                      <v-icon>mdi-file-document</v-icon>ประวัติ
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tabsHeaer">
                    <v-tab-item value="request_waiting">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">รายละเอียด</th>
                              <th class="text-center">สถานะ</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in dataItem" :key="item.welfareID">
                              <td>
                                ผู้ขอ : {{ item.empFull_NameTH }}<br />
                                ขอเบิก:
                                <strong>{{ item.welfareRequest }}</strong>
                                <br />
                                วันที่ : {{ item.welfare_date }} <br />
                              </td>
                              <td>
                                <v-btn
                                  v-if="item.welfare_status == 'verify'"
                                  class="ma-2"
                                  small
                                  dark
                                  color="red"
                                  elevation="2"
                                  @click="getInfo(item)"
                                >
                                  <v-icon>mdi-alert</v-icon> จัดการ
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-tab-item>
                    <v-tab-item value="approve_history">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #1b437c">
                              <th class="text-center">รายละเอียด</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dataItemDraft"
                              :key="item.welfareID"
                            >
                              <td>
                                ผู้ขอ : {{ item.empFull_NameTH }}<br />
                                ขอเบิก:
                                <strong>{{ item.welfareRequest }}</strong>
                                <br />
                                วันที่ : {{ item.welfare_date }} <br />
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            <p></p>
            <v-dialog v-model="dialogApprove">
              <v-card>
                <v-card-title class="text-h6 grey lighten-2">
                  <v-col class="text-right pb-0 pt-0 pr-0">
                    <v-icon color="#173053" @click="dialogApprove = false"
                      >mdi-close-circle</v-icon
                    >
                  </v-col>
                </v-card-title>
                <v-card-title class="pa-0 ml-6 mb-2">
                  <span class="headline">หมายเหตุ</span>
                </v-card-title>
                <v-card-text class="pa-4 pb-0">
                  <v-textarea
                    v-model="formUpdate.welfareRemark"
                    maxlength="100"
                    rows="3"
                    row-height="25"
                    outlined
                    :rules="nameRules"
                    clearable
                    clear-icon="mdi-close-circle"
                    label="หมายเหตุ"
                  ></v-textarea>
                </v-card-text>
                <v-card-actions class="pa-2 ma-2 mt-0">
                  <v-btn
                    color="red"
                    elevation="2"
                    dark
                    @click="updateStatus(formUpdate, 'cancel')"
                  >
                    ไม่อนุมัติ
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="success"
                    elevation="2"
                    dark
                    @click="updateStatus(formUpdate, 'confirm')"
                  >
                    อนุมัติ
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
// moment().format('YYYY')
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
export default {
  // name: 'Adjust Check IN-OUT',
  data () {
    return {
      dataReady: false,
      shifttem: [],
      formUpdate: [],
      dataItem: [],
      dataItemhistory: [],
      dataItemDraft: [],
      dataCountItem: 0,
      year: '',
      month: '',
      day: '',
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      tabs: 'request',
      tabsHeaer: 'request_waiting',
      profile: [],
      profileHR: [],
      form: {
        userLineuserId: '',
        userLinepictureUrl: ''
      },
      dialogApprove: false,
      currentMorDay: '',
      formRequest: [],
      nameRules: [(v) => !!v || 'Input is required'],
      valid_add: true
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    // this.currentMorDay = moment().add('days').format('YYYY-MM-DD')
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.getData()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getData () {
      await this.getDataRequest('verify')
      this.getDataRequest('history')
    },
    async getDataRequest (status) {
      var dataItem
      var dataItemhistory
      switch (status) {
        case 'verify':
          this.dataItem = []
          this.dataCountItem = 0
          dataItem = await this.requestAPI('&welfare_status=verify')
          if (dataItem.length > 0) {
            this.dataCountItem = dataItem.length
            this.tabs = 'request'
          }
          this.dataItem = dataItem.length > 0 ? dataItem : []
          break

        case 'history':
          this.dataItemDraft = []
          dataItemhistory = await this.getDataHistory()
          console.log('dataItemhistory.length', dataItemhistory.length)
          if (dataItemhistory.length > 0) {
            this.dataItemDraft = dataItemhistory
          }
      }
    },
    async requestAPI (url) {
      const dataItem = await axios.get(
        this.DNS_IP +
          '/welfare/get?welfare_year=' +
          this.year +
          '&welfare_month=' +
          this.getMonthThToINT(this.month) +
          url,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
      return dataItem.data ? dataItem.data : []
    },
    async getDataHistory () {
      const dataItemhistory = await axios.get(
        this.DNS_IP +
          '/welfare/get?welfare_year=' +
          this.year +
          '&welfare_month=' +
          this.getMonthThToINT(this.month) +
          '&LAST_USER_MGR=' + this.profile.empCode,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
      console.log('dataItemhistory', dataItemhistory.data)
      return dataItemhistory.data ? dataItemhistory.data : []
    },
    async getInfo (item) {
      this.formUpdate = []
      this.dialogApprove = true
      this.formUpdate = item
      this.formUpdate.welfareRemark = '-'
      await this.getEmployeeApproveHR(item)
    },
    async getEmployeeApproveHR (item) {
      console.log('getEmployeeApproveHR', item)
      this.profileHR = []
      // var message = 'คำเตือน : ไม่พบข้อมูลหัวหน้าของท่าน ระบบไม่สามารถส่งการแจ้งเตือนได้ กรุณาติดต่อฝ่ายบุคคล'
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/approve_permission/get?empCode=" + item.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.profileHR = response.data[0].userLineuserId_HRapprove
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async updateStatus (dt, status) {
      console.log('DT', dt)
      console.log('status', status)
      console.log('this.profileHR', this.profileHR)
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ' + status + 'ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#43A047',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.dataReady = false
          let ds = {
            welfareID: dt.welfareID,
            welfare_status: status,
            LAST_USER: this.profile.userName,
            LAST_USER_MGR: this.profile.empCode
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/welfare/updateMGR",
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.$swal('เรียบร้อย', 'ส่งข้อมูลเรียบร้อย', 'success')
              await this.setUpBeforeSendLine(dt)
              this.dialogApprove = false
              await this.getData()
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          this.getData()
          console.log(error)
        })
    },
    async setUpBeforeSendLine (item) {
      var payload = [
        {
          type: 'flex',
          altText: 'ขอสวัสดิการ',
          contents: {
            type: 'bubble',
            header: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'text',
                  text: 'แจ้งเตือนการร้องขอสวัสดิการ',
                  offsetBottom: 'none',
                  offsetTop: 'xs',
                  weight: 'bold',
                  position: 'relative',
                  align: 'start',
                  wrap: true
                }
              ],
              offsetBottom: 'md',
              backgroundColor: '#FFB8A1'
            },
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'horizontal',
                  contents: [
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'image',
                          url: 'https://api.betaskthai.com/upload/static/upload/Welfare/2022_09/EMP20218193_2022_09_30_16_49_50.png',
                          size: 'full',
                          margin: 'lg'
                        }
                      ],
                      cornerRadius: '100px',
                      width: '72px',
                      height: '72px'
                    },
                    {
                      type: 'box',
                      layout: 'vertical',
                      contents: [
                        {
                          type: 'text',
                          contents: [
                            {
                              type: 'span',
                              text: 'รอตรวจสอบเอกสารและผู้จัดการอนุมัติ',
                              weight: 'bold',
                              color: '#000000'
                            },
                            {
                              type: 'span',
                              text: '|'
                            }
                          ],
                          size: 'sm',
                          wrap: true
                        },
                        {
                          type: 'text',
                          text: 'hello, world',
                          contents: [
                            {
                              type: 'span',
                              text: item.welfareRequest,
                              color: '#D81B60'
                            }
                          ]
                        },
                        {
                          type: 'text',
                          text: 'hello, world',
                          contents: [
                            {
                              type: 'span',
                              text: item.empFull_NameTH,
                              color: '#1A237E'
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  spacing: 'xl',
                  paddingAll: '20px',
                  paddingTop: 'xs',
                  paddingBottom: 'xs'
                },
                {
                  type: 'separator'
                },
                {
                  type: 'box',
                  layout: 'baseline',
                  contents: [
                    {
                      type: 'text',
                      text: 'วันที่ทำรายการ',
                      flex: 1,
                      size: 'sm',
                      color: '#aaaaaa',
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: item.welfare_date,
                      size: 'sm',
                      color: '#666666',
                      wrap: true,
                      flex: 1,
                      align: 'center'
                    }
                  ],
                  paddingTop: 'md'
                }
              ],
              paddingAll: '0px',
              offsetTop: 'xs',
              spacing: 'none'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบสถานะ',
                    uri: 'line://app/1654154168-JML0KbN5?page=WelfareHistoryHR'
                  },
                  style: 'primary',
                  color: '#FFB8A1'
                }
              ]
            }
          }
        }
      ]
      await this.sendLinePush(payload, this.profileHR)
      this.dataReady = false
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/push_message",
          dt,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {})
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {})
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/WelfareHistoryBranch.vue